<template>
  <div class="pagination-container">
    <div class="bh-pagination-number">
      <!-- First page -->
      <button
          type="button"
          class="bh-page-item first-page"
          :class="{ disabled: currentPage === 1 }"
          @click="$emit('change-page', 1)"
      >
        <svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16">
          <g fill="currentColor" fill-rule="evenodd">
            <path d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path>
            <path d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path>
          </g>
        </svg>
      </button>

      <!-- Previous page -->
      <button
          type="button"
          class="bh-page-item previous-page"
          :class="{ disabled: currentPage === 1 }"
          @click="$emit('change-page', currentPage - 1)"
      >
        <svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16">
          <path fill="currentColor" fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path>
        </svg>
      </button>

      <!-- Page numbers -->
      <button
          v-for="p in visiblePages"
          :key="p"
          type="button"
          class="bh-page-item"
          :class="{ 'bh-active': p === currentPage }"
          @click="$emit('change-page', p)"
      >
        {{ p }}
      </button>

      <!-- Next page -->
      <button
          type="button"
          class="bh-page-item next-page"
          :class="{ disabled: currentPage === totalPages }"
          @click="$emit('change-page', currentPage + 1)"
      >
        <svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16">
          <path fill="currentColor" fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8L4.646 2.354a.5.5 0 0 1 0-.708z"></path>
        </svg>
      </button>

      <!-- Last page -->
      <button
          type="button"
          class="bh-page-item last-page"
          :class="{ disabled: currentPage === totalPages }"
          @click="$emit('change-page', totalPages)"
      >
        <svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16">
          <g fill="currentColor" fill-rule="evenodd">
            <path d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8L3.646 2.354a.5.5 0 0 1 0-.708z"></path>
            <path d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8L7.646 2.354a.5.5 0 0 1 0-.708z"></path>
          </g>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    visiblePages: { type: Array, required: true },
  }
}
</script>

<style scoped>
  .pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }

  .bh-pagination-number {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;

    .bh-page-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #dee2e6;
      background-color: white;
      color: #495057;
      font-size: 0.875rem;
      cursor: pointer;
      transition: all 0.2s ease;

      svg {
        display: block;
      }

      &:hover:not(.disabled):not(.bh-active) {
        background-color: #f1f3f5;
        border-color: #adb5bd;
      }

      &.bh-active {
        background-color: #0d6efd;
        color: white;
        border-color: #0d6efd;
        font-weight: 500;
      }

      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
</style>